import React, {useEffect, useState} from 'react';
import {usePresScaleContext} from '../../../../context/PresScaleContext';

function CenteredGridLines(): JSX.Element | null {
    const {workspaceSize} = usePresScaleContext();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onKey = (e: KeyboardEvent): void => {
            if (e.key === 'Control') setVisible(e.type === 'keydown');
        };
        document.addEventListener('keydown', onKey);
        document.addEventListener('keyup', onKey);
        return () => {
            document.removeEventListener('keydown', onKey);
            document.removeEventListener('keyup', onKey);
        };
    }, []);

    if (!visible) return null;

    return (
        <svg
            className="c-presGrid"
            width={workspaceSize.width}
            height={workspaceSize.height}
            viewBox={`0 0 ${workspaceSize.width} ${workspaceSize.height}`}
        >
            <line
                x1={workspaceSize.width / 2}
                x2={workspaceSize.width / 2}
                y1="0"
                y2={workspaceSize.height}
                stroke="orange"
                strokeWidth="1"
            />
            <line
                x1="0"
                x2={workspaceSize.width}
                y1={workspaceSize.height / 2}
                y2={workspaceSize.height / 2}
                stroke="orange"
                strokeWidth="1"
            />
        </svg>
    );
}

export default CenteredGridLines;
